import { render } from "./ScrollableView.vue?vue&type=template&id=65b6f391&scoped=true"
import script from "./ScrollableView.vue?vue&type=script&lang=js"
export * from "./ScrollableView.vue?vue&type=script&lang=js"

import "./ScrollableView.vue?vue&type=style&index=0&id=65b6f391&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b6f391"]])

export default __exports__